export const articlesCategoriesOwlets = [
  {
    title: 'Languages',
    image: require('../assets/languagesOwlets.png'),
  },
  { title: 'Math', image: require('../assets/mathOwlets.png') },
  {
    title: 'Science',
    image: require('../assets/socialSciencesOwlets.png'),
  },
  {
    title: 'Art',
    image: require('../assets/artsOwlets.png'),
  },
  {
    title: 'Sports',
    image: require('../assets/sportsOwlets.png'),
  },
]

export const articlesCategoriesOwls = [
  {
    title: 'Languages',
    image: require('../assets/languagesOwls.png'),
  },
  { title: 'Math', image: require('../assets/mathOwls.png') },
  {
    title: 'Science',
    image: require('../assets/naturalSciencesOwls.png'),
  },
  {
    title: 'Geography',
    image: require('../assets/geographyOwls.png'),
  },
  {
    title: 'History',
    image: require('../assets/historyOwls.png'),
  },
  { title: 'Ethics', image: require('../assets/ethicsOwls.png') },
  {
    title: 'Visual Arts',
    image: require('../assets/artsOwls.png'),
  },
  {
    title: 'Crafts',
    image: require('../assets/craftsOwls.png'),
  },
  {
    title: 'Music',
    image: require('../assets/musicOwls.png'),
  },
  {
    title: 'Sports',
    image: require('../assets/sportsOwls.png'),
  },
  {
    title: 'Nutrition',
    image: require('../assets/nutritionOwls.png'),
  },
]
